import {useSelector} from 'react-redux';

/**
 * Whether the current user is authenticated.
 * @returns {boolean}
 */
export const useIsAuthenticated = () => useSelector(state => state.user.isAuth);
